import { Site } from '@type';

import { SITE_DEFAULT_ASSET_ID, SITE_DEFAULT_LOGO } from './site.constant';

export const parseSite = (site: Partial<Site>, projectId: string): Site => ({
  siteUuid: site.siteUuid ?? '',
  name: site.name ?? '',
  phone: site.phone ?? '',
  email: site.email ?? '',
  siteId: site.siteId as number,
  address: site.address ?? '',
  assetId: site.assetId ?? SITE_DEFAULT_ASSET_ID,
  logoUrl: site.logoUrl ?? SITE_DEFAULT_LOGO,
  publicKey: site.publicKey ?? '',
  sourceRefId: `${projectId}/${site.siteId}`,
  sourceProjectId: projectId,
  additionalConsents:
    site.additionalConsents && typeof site.additionalConsents === 'string'
      ? (JSON.parse(site.additionalConsents) as string[])
      : [],
  privacyPolicyAssetLink: site.privacyPolicyAssetLink ?? '',
  isBlockchainActive: site.isBlockchainActive || false,
  isOnboardingRegistrationCodeEnabled:
    site.isOnboardingRegistrationCodeEnabled || false,
  isTelemedicineEnabled: site.isTelemedicineEnabled || false,
});
